import { Form, Select, Tooltip } from 'antd';
import React from 'react';
import { ReactComponent as SelectDropdownSvg } from '../../assets/icons/select-dropdown.svg';
import { ReactComponent as SelectDropdownBlackSvg } from '../../assets/icons/select-dropdown-black.svg';
import { useTheme } from '../../context/ThemeContext';
import Icon from '@ant-design/icons';
import { DARK } from '../../utilities/constants';
import PropTypes from 'prop-types';
import EmptyCard from '../EmptyCard/EmptyCard';

const CustomFormDropdown = ({
  label,
  placeholder,
  name,
  rules,
  options,
  onChange = () => {},
  size = 'large',
  width = '100%',
  disabled = false,
  mode = undefined,
  defaultValue = null,
  showTooltip = false,
  tooltipText = '',
  tooltipPlacement = 'bottom',
}) => {
  const { theme } = useTheme();
  const select = (
    <Select
      disabled={disabled}
      placeholder={placeholder}
      options={options}
      size={size}
      onChange={onChange}
      style={{ width: '100%' }}
      {...(defaultValue != null && { defaultValue })}
      suffixIcon={
        <Icon
          component={
            theme === DARK ? SelectDropdownSvg : SelectDropdownBlackSvg
          }
          style={{
            pointerEvents: 'none',
          }}
        />
      }
      mode={mode}
      showSearch
      notFoundContent={<EmptyCard />}
    />
  );

  return (
    <Form.Item
      className="custom-select-dropdown"
      name={name}
      rules={rules}
      label={label}
      style={{ width }}
    >
      {disabled && showTooltip && tooltipText ? (
        <Tooltip title={tooltipText} placement={tooltipPlacement}>
          <div style={{ width: '100%' }}>{select}</div>
        </Tooltip>
      ) : (
        select
      )}
    </Form.Item>
  );
};

CustomFormDropdown.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  placeholder: PropTypes.string,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  rules: PropTypes.arrayOf(PropTypes.object),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      disabled: PropTypes.bool,
    })
  ).isRequired,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['small', 'middle', 'large']),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  mode: PropTypes.oneOf(['multiple', 'tags', 'default']),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  showTooltip: PropTypes.bool,
  tooltipText: PropTypes.string,
  tooltipPlacement: PropTypes.oneOf([
    'top',
    'left',
    'right',
    'bottom',
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'leftTop',
    'leftBottom',
    'rightTop',
    'rightBottom',
  ]),
};

export default CustomFormDropdown;
